import { Badge } from '@/components/atoms/badge';
import { Button } from '@/components/atoms/button';

const fmt = (n: number) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);

interface PricebookResultRowProps {
  name: string;
  code: string;
  type: string;
  basePrice: number;
  unit?: string;
  onAdd: () => void;
}

export function PricebookResultRow({
  name,
  code,
  type,
  basePrice,
  unit,
  onAdd,
}: PricebookResultRowProps) {
  return (
    <div className="flex items-center gap-3 px-3 py-2 hover:bg-muted/50">
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{name}</p>
        <p className="text-xs text-muted-foreground">
          {code} · {fmt(basePrice)}
          {unit ? ` / ${unit}` : ''}
        </p>
      </div>
      <Badge variant="secondary" className="text-xs capitalize shrink-0">
        {type}
      </Badge>
      <Button size="sm" variant="outline" onClick={onAdd} className="shrink-0">
        + Add
      </Button>
    </div>
  );
}
